<template>
<w-setting-sliding-popup ref="slidingPopup" title="정책 추가" width="400px" @close="close">
  <div slot="content">
    <el-form ref="ruleForm" :rules="rules" :model="ruleData">
      <el-row>
        <el-form-item prop="ruleTmplId" label="정책 아이디">
          <el-input v-model="ruleData.ruleTmplId" />
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item prop="ruleTmplName" label="정책명">
          <el-input v-model="ruleData.ruleTmplName" />
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item prop="copyRuleTmplId" label="복사할 정책">
          <el-select style="width: 100%;" v-model="ruleData.copyRuleTmplId">
            <el-option v-for="item in ruleList" :key="item.ruleTmplId" :label="item.ruleTmplName" :value="item.ruleTmplId" />
          </el-select>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item prop="ruleTmplDesc" label="설명">
          <el-input type="textarea" :rows="7" v-model="ruleData.ruleTmplDesc" />
        </el-form-item>
      </el-row>
    </el-form>
  </div>
  <div slot="footer">
    <el-button size="large" type="solid" @click="saveRule">저장</el-button>
    <el-button size="large" @click="onCancelButtonClick">취소</el-button>
  </div>
</w-setting-sliding-popup>
</template>

<script>
import { isEmpty, find } from 'lodash';
import { ruleType } from '@/constants/rule';
import msgUtil from '@/utils/message';
import RuleAPI from '@/api/settings/common/rule';
import RscRuleAPI from '@/api/settings/common/rule-settings';
import EventRuleAPI from '@/api/settings/common/event-alarm-rule-settings';

export default {
  name: 'WAddRulePopup',
  props: {
    ruleType: {
      type: String,
      required: true,
    },
    managetypeId: {
      type: String,
    },
  },
  data() {
    return {
      ruleData: {
        // 정책 정보
        ruleTmplId: '',
        ruleTmplName: '',
        ruleTmplDesc: '',
        copyRuleTmplId: '',
      },
      rules: {
        // 정책 폼 rules
        ruleTmplId: [
          {
            required: true,
            trigger: 'blur',
            validator: this.validateRuleId,
          },
        ],
        ruleTmplName: [
          {
            required: true,
            trigger: 'blur',
            message: '정책명을 입력해주십시오.',
          },
        ],
        copyRuleTmplId: [
          {
            required: true,
            trigger: 'blur',
            message: '복사할 정책을 선택해주십시오.',
          },
        ],
      },
      ruleList: [], // 복사할 정책 목록
    };
  },
  methods: {
    /**
     * 정책 추가 팝업을 연다.
     * @author Ju
     */
    open() {
      this.$refs.slidingPopup.open();
      this.loadRules();
    },
    /**
     * 정책 추가 팝업 닫기 이벤트 핸들러
     * @author Ju
     */
    close() {
      this.ruleData = {
        ruleTmplId: '',
        ruleTmplName: '',
        ruleTmplDesc: '',
        copyRuleTmplId: '',
        ruleList: [],
      };
      this.$refs.ruleForm.clearValidate();
    },
    /**
     * 취소 버튼 이벤트 핸들러
     * @author Ju
     */
    onCancelButtonClick() {
      this.$refs.slidingPopup.close();
    },
    /**
     * 복사할 정책 목록을 로드한다.
     * @author Ju
     */
    loadRules() {
      if (this.ruleType === ruleType.RSC) {
        RuleAPI.getRscEventRules().then((response) => {
          this.setRuleList(response.data.data);
        });
      } else {
        RuleAPI.getEventAlarmRulesByManagetypeId(this.managetypeId).then((response) => {
          this.setRuleList(response.data.data);
        });
      }
    },
    /**
     * 복사할 정책 목록을 설정한다.
     * @author Ju
     */
    setRuleList(ruleList) {
      this.ruleList = ruleList;
      this.$nextTick(() => {
        if (!isEmpty(this.ruleList)) {
          this.ruleData.copyRuleTmplId = this.ruleList[0].ruleTmplId;
        }
      });
    },
    validateRuleId(rule, value, callback) {
      if (isEmpty(value)) {
        callback(new Error('정책 아이디를 입력해주십시오.'));
        return;
      }

      if (this.ruleType === ruleType.RSC) {
        RscRuleAPI.checkDuplicateCollectionJudgementRule(value)
          .then((response) => {
            if (response.data.success && response.data.data) {
              callback(new Error('이미 존재하는 정책 아이디입니다.'));
            } else {
              callback();
            }
          })
          .catch(() => {
            callback();
          });
      } else {
        EventRuleAPI.checkDuplicateEventAlarmRule(value, this.managetypeId)
          .then((response) => {
            if (response.data.success && response.data.data) {
              callback(new Error('이미 존재하는 정책 아이디입니다.'));
            } else {
              callback();
            }
          })
          .catch(() => {
            callback();
          });
      }
    },
    /**
     * 정책을 저장한다.
     * @return {[type]} [description]
     * @author jda
     */
    saveRule() {
      const ruleData = this.ruleData;
      const duplicatedRule = find(this.ruleList, {
        ruleTmplId: ruleData.ruleTmplId,
      });
      if (!isEmpty(duplicatedRule)) {
        this.$message(msgUtil.getCustomMsgData('이미 존재하는 정책 아이디입니다.'));
        return;
      }

      // 수집/판단 정책
      if (this.ruleType === ruleType.RSC) {
        RscRuleAPI.addCollectionJudgementRule(this.ruleData).then((response) => {
          if (response.data.success) {
            this.onCancelButtonClick();
            this.$emit('close');
          }
          this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '정책', response.data.success));
        });
      } else {
        // 이벤트/알람 정책
        const rule = {
          ...this.ruleData,
          ruleTmplId: `${this.managetypeId}_${this.ruleData.ruleTmplId}`,
          managetypeId: this.managetypeId,
        };
        EventRuleAPI.addEventAlarmRule(rule).then((response) => {
          if (response.data.success) {
            this.onCancelButtonClick();
            this.$emit('close');
          } else if (!response.data.success && response.data.message === 'Duplicate') {
            this.$message(msgUtil.getCustomMsgData('이미 존재하는 정책 아이디입니다.'));
            return;
          }
          this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '정책', response.data.success));
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/popup/AddRulePopup.vue